<template>
    <div>
        <vs-row class="mb-4">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-end" vs-w="12">
                <vs-button class="mr-3" color="primary" type="border" icon-pack="feather" icon="icon-arrow-left" @click="_isMigrate()"></vs-button>
                <div class="w-1/4 mr-3">
                    <label for="" class="vs-input--label">Seleccione grupo</label>
                    <v-select v-model="selectGroup" class="w-full bg-white" :options="Group" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>                
                <vs-button class="mr-3" type="border" text-color="#28C76F" @click="Valdiator">Validar</vs-button>
                 <vs-button type="border" text-color="#28C76F" :disabled="btnDisabled" @click="saveForm">Guardar</vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mb-4">
			<vs-col vs-type="flex" vs-justify="flex-start" :vs-w="col1">
                <div class="w-full">
                    <p class="font-bold">Formulario versión 1</p>
                    <json-viewer class="w-full" :value="TRANSPFORFORM" :expand-depth=10  copyable></json-viewer>
                </div>  
                					
			</vs-col>
            <vs-col vs-type="flex" vs-justify="flex-start" :vs-w="col1">	
                <div class="w-full">
                    <p class="font-bold">Formulario versión 2</p>
                    <json-editor class="w-full h-full" v-model="ONEFORM"></json-editor>
                </div>               			
			</vs-col>
            <!-- <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-end" vs-w="3">				
			</vs-col> -->
            <vs-col vs-type="flex" vs-justify="flex-start" :vs-w="colError">	
                <div class="w-full">
                    <h4 v-if="msg !== ''" class="text-center w-full" :class="[colorText]">{{msg}}</h4>		
                    <json-viewer v-if="dataError !== ''" class="w-full" :value="dataError" :expand-depth=10  copyable></json-viewer>
                </div>
			</vs-col>
		</vs-row>

    </div>
</template>

<script>
    import JsonEditor from 'vue-json-formatter-editor';
    import Api from '@/helpers/api';

    import { validationStandard } from '../designer/validateSchema/standarSchema.js';
    
    import { main } from './migrate';
    import { ModelA } from './schema/ShemaA';
    import { ModelB } from './schema/ShemaB';
    import { ModelC } from './schema/ShemaC';

    import { notify } from '@/helpers/$vs.js';

    import vSelect from 'vue-select'

    export default {
        props: ['oneForm', '_isMigrate', 'Group'],
        components: {
            JsonEditor ,
            vSelect		
        },
        data() {
            return {
                formEdit: [],
                btnDisabled: true,
                msg: '',
                colorText: '',
                dataError: '',
                selectGroup: '',
                formToSave: [],
            }
        },
        methods: {
            _convert(data) {           
                let newData = [];
                let _date= ["datetime", "time", "date", "video", "signature", "location", "map", "geo", "boolean", "datasource", "multiInput", "info" , "subform"];
                let Choice = [ "multiChoice", "uniqueChoice"];

                let item = {};
                for(let i in data) {   
                    if(data[i].type !== "photoML" || data[i].type !== "uniqueChoiceCompound" ) {
                        if(_date.includes(data[i].type)) {       
                                        
                            item = main(ModelB, {...data[i]});                        
                            if(item.type === "subform") {                            
                                item.inherited[0].form.questions = this._convert(item.inherited[0].form.questions );
                            }
                        }else if(Choice.includes(data[i].type)) {
                            item = main(ModelC, {...data[i]});
                            if(item.inputType === 'radio') {
                                item.properties = {
                                    default: 'radio'
                                }
                            }
                        } else {
                            item = main(ModelA, {...data[i]});                    
                        }               
                        if(item.help === "") delete item.help;

                        newData.push(item);
                    }
                    
                } 
                return newData;        
            },
            _isSubForm(isSubForm) {
                if(isSubForm === null || isSubForm === undefined) return 'standar';
                if(isSubForm) return 'standar';
                else return 'subforms';
            },
            hasSubforms(questions) {
                const hasSubform = questions.filter(item => item.type === 'subform');               
                const subforms = hasSubform.map((item, index) => {
                    return {
                        "activity": item.inherited[0].activity,
                        "formID": item.inherited[0].formID,
                        "version": item.inherited[0].version,
                        "min": 1,
                        "max": 1,
                        "question": questions.findIndex(question => question.name === item.name),
                        "questionID": item.name
                    }
                });               
                
                if(hasSubform.length > 0) return { hasForm: true, subforms };
                return { hasForm: false, hasSubform: null };
            },
            databases(questions) {
                const hasdatabases = questions.filter(item => item.type === 'datasource');
                const databases = hasdatabases.map((item => {
                    return {
                        "originID": '_is_Null_Origin_Key_',
                        "limit": 20,
                        "question": item.name,
                        "questionID": questions.findIndex(question => question.name === item.name),
                        "columns": Object.keys(item.data[0])                        
                    }
                }));

                if(hasdatabases.length > 0) return { hasdatabases: true, databases };
                return { hasdatabases: false, databases: null };
            },
            async Valdiator() {
                try {                 
                    this.dataError = '';   
                    const hasSubForms = this.hasSubforms(this.formEdit);
                    const hasDatabases = this.databases(this.formEdit);
                    let  newData = {
                    "schema": "create",
                    "data": {
                            "activity": this.oneForm.activity,
                            "groupID": this.oneForm.formID,
                            "formType": this.oneForm.formType,
                            "SFVersion": 2,
                            "hasSubForms": hasSubForms.hasForm,
                            "form": {
                                pages: this.oneForm.form.pages,
                                questions: this.formEdit
                            }
                        }
                     };

                    
                    if(hasSubForms.hasForm) newData.data.subforms = hasSubForms.subforms;
                    if(hasDatabases.hasdatabases) newData.data.databases = hasDatabases.databases;                   
                    
                   
                    const result = validationStandard(newData.data.form.questions);
                    if(!result.valid) {
                        console.log('Error Error ',result.error);
                        throw result.error;
                    }
                    
                    await Api.post('/validator', newData);

                    this.formToSave = newData.data;
                    this.btnDisabled = false;
                    this.msg = "success!"
                    this.colorText = 'text-success'
                } catch (error) {
                    this.formToSave = [];
                    this.btnDisabled = true;
                    this.msg = "Validation Error!"
                    this.colorText = 'text-danger'
                    this.dataError = error.error?error.error:error;
                }
            },
            async saveForm(){
                try {
                    if(this.selectGroup === '') return notify('Grupo', 'Seleccione el grupo.', 'danger');
                    this.formToSave.groupID = this.selectGroup.value;                    
                    const result = await Api.post('/forms', this.formToSave);
                    notify('Formulario', 'Formulario guardado.');
                } catch (error) {
                    notify('Formulario', 'Error al guardar el formulario.', 'danger');
                    console.log('Error ',error)
                }
            }
        },
        computed: {
            ONEFORM: {
                get() {
                    if(this.oneForm.hasOwnProperty('form')) {
                        if(this.oneForm.form.hasOwnProperty('questions')) {
                            
                            const convert = this._convert(this.oneForm.form.questions);
                            this.formEdit = convert;
                            return JSON.stringify(convert);
                        }
                    }
                this.formEdit = this.oneForm;
                return JSON.stringify(this.oneForm);
                },
                set(value) {
                    this.formEdit = JSON.parse(value);
                }
            },
            TRANSPFORFORM() {
                 if(this.oneForm.hasOwnProperty('form')) {
                        if(this.oneForm.form.hasOwnProperty('questions')) {
                            return this.oneForm.form.questions;
                        }
                    }
                return JSON.stringify(this.oneForm); 
            },
            col1() {
                return this.dataError === ''?'5':'4'
            },
            colError() {
                return this.dataError === ''?'2':'4'
            }  
        }        
    }
</script>

<style lang="scss" scoped>

</style>